import { CrudForm } from '../shared/CrudPage';
import { bankService } from '@kss/api';
import type { Bank, BankCreate, BankFilter } from '@kss/api';

type F = {
  code: string;
  name: string;
  description: string;
  status: string;
  remarks: string;
  swiftCode: string;
  ifscPrefix: string;
  country: string;
  isActive: boolean;
};

const empty: F = {
  code: '',
  name: '',
  description: '',
  status: '',
  remarks: '',
  swiftCode: '',
  ifscPrefix: '',
  country: 'IN',
  isActive: true,
};

export default function NewBank() {
  return (
    <CrudForm<Bank, BankCreate, BankFilter, F>
      title="bank"
      service={bankService}
      idKey="bankId"
      basePath="/panel/banks"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name', required: true, placeholder: 'HDFC Bank' },
        { key: 'swiftCode', label: 'SWIFT' },
        { key: 'ifscPrefix', label: 'IFSC prefix', placeholder: 'HDFC0' },
        { key: 'country', label: 'Country' },
        { key: 'isActive', label: 'Status', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: ((r as unknown as Record<string, unknown>).code ?? '') as string,
        name: ((r as unknown as Record<string, unknown>).name ?? '') as string,
        description: ((r as unknown as Record<string, unknown>).description ?? '') as string,
        status: ((r as unknown as Record<string, unknown>).status ?? '') as string,
        remarks: ((r as unknown as Record<string, unknown>).remarks ?? '') as string,
        swiftCode: ((r as unknown as Record<string, unknown>).swiftCode ?? '') as string,
        ifscPrefix: ((r as unknown as Record<string, unknown>).ifscPrefix ?? '') as string,
        country: ((r as unknown as Record<string, unknown>).country ?? '') as string,
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        bankId: id,
        code: f.code ? f.code : undefined,
        name: f.name ? f.name : undefined,
        description: f.description ? f.description : undefined,
        status: f.status ? f.status : undefined,
        remarks: f.remarks ? f.remarks : undefined,
        swiftCode: f.swiftCode ? f.swiftCode : undefined,
        ifscPrefix: f.ifscPrefix ? f.ifscPrefix : undefined,
        country: f.country ? f.country : undefined,
        isActive: f.isActive,
      } as Bank)}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
